module.exports = __webpack_public_path__ + "h5/img/summer-nav2-1.659afa0a.png";